<template>
    <div class="MyBusinessCard">
        <div class="noOrders" v-if="orderList.length == 0">
            <div class="imageEmptyStock">
                <img src="../../../assets/images/orderEmpty.png" alt />
            </div>
            <div v-if="!firstLoading">还没有订单哦...</div>
            <van-loading v-else type="spinner" />
        </div>
        <div class="scroll" v-if="orderList.length > 0">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了~" @load="onLoad"
                :immediate-check="false" class="cardDetailList">
                <div v-for="(item, index) in orderList" :key="index">
                    <div class="cardItem">
                        <div class="flex" style="padding: 16px;">
                            <div style="width: 70px;height:70px;margin-right: 12px;">
                                <img :src="item.goodsPicture" alt="">
                            </div>
                            <div class="orderItemWidth">
                                <div class="ellipsisText">
                                    {{ item.goodsName }}
                                </div>
                                <div class="detailSpec">
                                    {{ item.goodsSpecificationName }}
                                </div>
                                <div class="smallSize">
                                    购买数量：{{ item.buyNumber }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </van-list>
        </div>
        <van-overlay :show="isLoading">
            <div class="wrapper">
                <loading v-if="isLoading == true"></loading>
            </div>
        </van-overlay>
    </div>
</template>
<script>
// import service from "../../api/order/index";
import service from "../../api/myShare/index";
import loading from "../loading/loading";
import {
    Card,
    Panel,
    List,
    Loading,
    Form,
    Field,
    Overlay,
    Icon,
    Popup, CellGroup, Toast, Dialog, Button, Notify, ImagePreview
} from "vant";
import { mapGetters } from "vuex";
import vueQr from "vue-qr";
export default {
    data() {
        return {
            imageUrl: '',
            status: false,
            fileList: [],
            pictureList: [],
            userAllMes: {
                pictureUrlList: [],
            },
            isLoading: true, //loading状态
            show: false,
            orderStatusId: "",
            orderList: [],
            noDate: false, //这是一个判断是否加载的开关
            arr: [],
            page: 1,
            pageSize: 20,
            loading: false,
            finished: false,
            orderStatusText: "",
            firstLoading: true,
        };
    },
    components: {
        [Card.name]: Card,
        [Panel.name]: Panel,
        [List.name]: List,
        [Loading.name]: Loading,
        [Form.name]: Form,
        [Field.name]: Field,
        [Overlay.name]: Overlay,
        [Icon.name]: Icon,
        [Popup.name]: Popup,
        [CellGroup.name]: CellGroup,
        [Toast.name]: Toast,
        [Dialog.name]: Dialog,
        [Button.name]: Button,
        [Notify.name]: Notify,
        [ImagePreview.Component.name]: ImagePreview.Component,
        vueQr,
        loading
    },
    props: {
        msg: {
            type: Object
        }
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    mounted() {
        this.init()
        console.log(this.msg, "this.msg")
    },
    methods: {
        onLoad() {
            this.page++;
            // 代买
            if (this.msg.type == 1) {
                this.getAgentList().then((orderList) => {
                    this.orderList = this.orderList.concat(orderList.items);
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 500);
                    this.loading = false;
                    if (orderList.totalCount <= this.orderList.length) {
                        this.finished = true;
                    }
                });
            }
            if (this.msg.type == 2) {
                this.getList().then((orderList) => {
                    this.orderList = this.orderList.concat(orderList.items);
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 500);
                    this.loading = false;
                    if (orderList.totalCount <= this.orderList.length) {
                        this.finished = true;
                    }
                });
            }

        },
        init() {
            this.page = 1;
            this.firstLoading = true;
            this.loading = false;
            // 代买
            if (this.msg.type == 1) {
                this.getAgentList()
                    .then((orderList) => {
                        setTimeout(() => {
                            this.isLoading = false;
                        }, 500);
                        this.orderList = orderList.items;
                        this.finished = false;
                        this.firstLoading = false;
                        if (orderList.totalCount <= this.orderList.length) {
                            this.finished = true;
                            this.loading = false;
                        }
                    })
                    .catch((err) => {
                        this.isLoading = false;
                    });
            }
            // 
            if (this.msg.type == 2) {
                this.getList()
                    .then((orderList) => {
                        setTimeout(() => {
                            this.isLoading = false;
                        }, 500);
                        this.orderList = orderList.items;
                        this.finished = false;
                        this.firstLoading = false;
                        if (orderList.totalCount <= this.orderList.length) {
                            this.finished = true;
                            this.loading = false;
                        }
                    })
                    .catch((err) => {
                        this.isLoading = false;
                    });
            }
        },
        getList() {
            return new Promise((resolve, reject) => {
                service
                    .detail(this.msg.userId, this.page, this.pageSize)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        // reject();
                    });
            });
        },
        getAgentList() {
            return new Promise((resolve, reject) => {
                service
                    .agentDetail(this.msg.name, this.page, this.pageSize)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        // reject();
                    });
            });
        },
    },
};
</script>
<style lang="less" scoped>
@deep: ~">>>";

// 更改组件图片大小
@{deep}.van-card .van-card__thumb {
    width: 70px;
    height: 70px;
}

@{deep}.van-card .van-card__thumb img {
    width: 70px;
    height: 70px;
}

.van-card__num {
    margin-bottom: 5px;
    float: left;
}



[class*="van-hairline"]::after {
    border: none;
}

.cardDetailList {
    .van-card {
        background: #fff;
        margin: 0 4.26667vw;
        padding: 4vw 0;
    }
}

.MyBusinessCard {
    width: 327px;
    height: 468px;
    padding: 0 16px 0 0;
    overflow-y: scroll;

    .noOrders {
        padding-top: 20vw;
    }
    .scroll {
        padding: 53px 0 0 16px;
    }

    // 每一个商品
    .cardItem {
        height: 102px;
        background: #FFFFFF;
        box-shadow: 0px 4px 8px 1px #EBEBEB;
        border-radius: 8px 8px 8px 8px;
        opacity: 1;
        border: 0.5px solid #E6E6E6;
        margin-bottom: 8px;
    }

    // 没有更多了
    @{deep}.van-list__finished-text {
        line-height: 16px;
        padding: 8px 0 16px;
    }

    // 描述
    .detailSpec {
        font-size: 12px;
        color: #999999;
        padding: 8px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

}
</style>
  